export enum PostingTypeEnum {
    Program = 'program',
    E_learning = 'e_learning',
    Course = 'course',
}
